import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import CaseNotificationEnum, { findStatusTitleByIdForInternalUser } from "../../enums/CaseNotiFicationEnum";
import "./ExportToExcel.css";
import { FaFileExcel } from "react-icons/fa";

function ExportToExcel({ data, caseFiles, deletedFiles, fileName }) {
    const caseRoles = {
        null: "შემსრულებელი",
        1: "შემსრულებელი",
        2: "ვიზატორი",
        3: "მეორადი შემსრულებელი",
        4: "ვიზატორი",
        5: "მეორადი შემსრულებელი",
    };

    const findFileById = (fileId) => {
        const file = caseFiles.find(file => file.id === fileId);
        const deletedFile = deletedFiles.find(file => file.id === fileId);
        return file || deletedFile || "";
    };

    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') return 'თარიღი არ მოიძებნა';
        const date = new Date(dateString);
        if (isNaN(date)) return 'თარიღი არ მოიძებნა';
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ` +
            `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    };

    const handleExport = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Data');

        const headers = [
            { header: 'ვისგან', key: 'lastStepUserFullName' },
            { header: 'ვის', key: 'nextStepUserFullName' },
            { header: 'ქმედება', key: 'action' },
            { header: 'თარიღი', key: 'createAt' },
            { header: 'დოკუმენტი', key: 'documentId' }
        ];

        worksheet.columns = headers.map(h => ({ ...h, width: h.header.length }));

        data.forEach(item => {
            const actionText = findStatusTitleByIdForInternalUser(item.action);
            const userType = item.action === CaseNotificationEnum.added.id ? ` (${caseRoles[item['сaseRole']]})` : "";
            const fileDetails = item.documentId ? findFileById(item.documentId) : "";

            const rowData = {
                lastStepUserFullName: item.lastStepUserFullName,
                nextStepUserFullName: item.nextStepUserFullName,
                action: actionText + userType,
                createAt: formatDate(item.createAt),
                documentId: fileDetails ? fileDetails.name + " (დოკუმენტის გახსნა)" : ""
            };

            const row = worksheet.addRow(rowData);

            if (fileDetails) {
                row.getCell('documentId').value = {
                    text: fileDetails.name + " (დოკუმენტის გახსნა)",
                    hyperlink: fileDetails.path
                };
                row.getCell('documentId').font = { color: { argb: '0000FF' }, underline: true };
            }

            headers.forEach((h, i) => {
                const val = rowData[h.key] || "";
                worksheet.columns[i].width = Math.max(worksheet.columns[i].width, val.toString().length + 10);
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${fileName}.xlsx`);
    };


    return (
        <button onClick={handleExport} className="excel-button-casehistory">
            <FaFileExcel style={{ marginRight: '8px' }} />
            ექსელში ექპორტი
        </button>
    );
}

export default ExportToExcel;
